import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

export default class extends Controller {
  static values = { options: Object }

  connect() {
    this.chart = echarts.init(this.element)

    if (this.hasOptionsValue) {
      this.chart.setOption(this.optionsValue)
    }

    this.resizeObserver = new ResizeObserver(() => this.chart.resize())
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    this.chart.dispose()
    this.resizeObserver.disconnect()
  }
}
